import { render, staticRenderFns } from "./TranslationOverview.vue?vue&type=template&id=89fd3000&"
import script from "./TranslationOverview.vue?vue&type=script&lang=js&"
export * from "./TranslationOverview.vue?vue&type=script&lang=js&"
import style0 from "./TranslationOverview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCardText,VExpandTransition,VIcon,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89fd3000')) {
      api.createRecord('89fd3000', component.options)
    } else {
      api.reload('89fd3000', component.options)
    }
    module.hot.accept("./TranslationOverview.vue?vue&type=template&id=89fd3000&", function () {
      api.rerender('89fd3000', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/TranslationOverview.vue"
export default component.exports